module.exports = __webpack_public_path__ + "img/42.fcd1daa9.jpg";